import { DatasetCreationEnum } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { InfoFormLabel, MultipleSelect, SelectOption } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';

const DataLocationField = () => {
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.GEO_LOCATION });
  const { hasLockedStatus } = useHasLockedStatus();

  const selectOptions: SelectOption[] =
    data?.map(({ value, key }) => ({
      value: key,
      label: value.replace('GeoLocation_', ' '),
    })) || [];

  return (
    <MultipleSelect
      name="geo_location_tags"
      label={
        <InfoFormLabel label="DATA LOCATION" tooltipText="Please select all data locations the dataset includes." />
      }
      options={selectOptions}
      placeholder="Select the location"
      required
      disabled={isFetching || hasLockedStatus}
    />
  );
};

export default DataLocationField;
